import useSessionKeepAlive from 'components/hooks/useSessionKeepAlive'
import React, { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import Header from '../common/Header'
import useLoaderFormData from '../common/hooks/useLoaderFormData'
import { usePromptIfUnsaved } from '../common/hooks/usePromptIfUnsaved'
import Sidebar from '../common/sidebars/Sidebar'
import Toolbar from '../common/toolbar/Toolbar'
import AssignSection from '../features/section'
import Loader from './Loader'

export const TAB_NAVIGATOR = Object.freeze({
  BUILD: 'build',
  ASSIGN: 'assign',
  PREVIEW: 'preview',
})

const BuildSection = ({ loaded }) => {
  return (
    <div className="main">
      <Sidebar navLabels={['Fields', 'Pages']} sidebarClasses="left-sidebar" navClasses="left-nav" />
      <div className="center-area">
        <Toolbar />
        <Loader />
      </div>
      <Sidebar navLabels={['Properties', 'Data']} sidebarClasses="right-sidebar" navClasses="right-nav" />
    </div>
  )
}

const Main = () => {
  const hasChanges = useSelector(({ pages }) => pages.hasChanges)
  const [activeTab, setActiveTab] = useState(TAB_NAVIGATOR.BUILD)
  const { isInitialDataFetched, loading, refeshData } = useLoaderFormData()

  const onPingSuccess = useCallback((response) => {
    if (response?.data && !response.data.signed_in) {
      alert('Your session has expired. Please refresh the page and sign in again.')
    }
  }, [])

  useSessionKeepAlive({ onPingSuccess })
  usePromptIfUnsaved(hasChanges)

  if (!isInitialDataFetched) return null

  return (
    <div className="form-builder">
      <Header loading={loading} activeTab={activeTab} onSave={refeshData} onTabChange={(e) => setActiveTab(e)} />
      <div className="dome-relative">
        <div
          style={{
            visibility: activeTab === TAB_NAVIGATOR.BUILD ? 'visible' : 'hidden',
          }}
        >
          <BuildSection />
        </div>
        <div
          style={{
            visibility: activeTab === TAB_NAVIGATOR.ASSIGN ? 'visible' : 'hidden',
            position: 'absolute',
            width: '100%',
            left: 0,
            top: 0,
            opacity: activeTab === TAB_NAVIGATOR.ASSIGN ? '1' : '0',
          }}
        >
          <AssignSection />
        </div>
      </div>
    </div>
  )
}

export default Main
